import React from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const MemberBillingAdjustments = (props) => {
  const membershipId = props.match.params.memberID
  const token = window.localStorage.getItem('auth-token')
  const { operator: { id, name, currency } } = React.useContext(AppContext)

  if (!id) {
    return (
      <div>
        <p>Loading...</p>
      </div>
    )
  }

  console.log('billing-adjustments...')

  return (
    <>
      <cl-member-billing-adjustments
        apiHost={`https://memberships.${env()}.credlock.net`}
        mountPath={`/operators/${id}/members/${membershipId}/billing-adjustments`}
        operatorid={id}
        operatorName={name}
        operatorCurrency={currency}
        token={token}
        membershipId={membershipId}
      />
    </>
  )
}

export default MemberBillingAdjustments
